const ResumeApi = [
  // --- EDUCATION ---
  {
    id: 1,
    category: "education",
    year: "International University of Scholars (2024 - 2028)",
    title: "B.Sc. Electrical & Electronics Engineering",
    desc: "Specializing in embedded architectures, digital signal processing (DSP), and advanced control theory to architect the hardware-software bridges required for autonomous robotics.",
    skills: ["Embedded Systems", "Control Theory", "DSP"]
  },
  {
    id: 2,
    category: "education",
    year: "M.A Hashem University College (2023)",
    title: "Higher Secondary Certificate (Science)",
    desc: "Concentration in advanced calculus and physical sciences, establishing the theoretical framework for rigid body kinematics and electromagnetic principles.",
    skills: ["Advanced Calculus", "Physics", "Kinematics"]
  },
  {
    id: 3,
    category: "education",
    year: "Chilonia Union High School (2021)",
    title: "Secondary School Certificate",
    desc: "Foundational coursework in mathematics and physical sciences, initiating a trajectory toward complex electromechanical systems engineering.",
    skills: ["Mathematics", "Physical Sciences"]
  },

  // --- EXPERIENCE ---
  {
    id: 4,
    category: "experience",
    year: "Engineering Head (Aug 2024 - Present)",
    title: "Team RoboMore",
    desc: "Directing a cross-functional engineering team in the R&D of autonomous UAVs and ground robotics. Architecting the sn21 Transwing VTOL flight dynamics and recently led the team to secure 2nd and 3rd place finishes at the 2026 BUET Robocarnival.",
    skills: ["Team Leadership", "sn21 VTOL", "Altium Designer"]
  },
  {
    id: 5,
    category: "experience",
    year: "Project Lead (2025)",
    title: "Team Echo Drift & Dynamic Spark",
    desc: "Spearheaded the design and programming of highly autonomous mechatronic systems. Led Team Echo Drift to the World Robot Olympiad (WRO) International Final in Singapore, securing an official 29th place global ranking.",
    skills: ["WRO 2025 Singapore", "Line Follower Robots", "STM32"]
  },
  {
    id: 6,
    category: "experience",
    year: "Embedded System Engineer (Feb 2024 - Dec 2024)",
    title: "Drishti Technologies Ltd.",
    desc: "Engineered ultra-low-power embedded architectures for enterprise wearables. Optimized bare-metal firmware, executed complex micro-camera integrations, and managed PDN stability across HDI rigid-flex boards.",
    skills: ["C/C++ Firmware", "I2C/SPI", "Power Optimization"]
  },
  {
    id: 7,
    category: "experience",
    year: "Industrial IoT Engineer (Feb 2024 - Dec 2024)",
    title: "Ongshak",
    desc: "Architected and deployed robust Industrial IoT (IIoT) edge nodes tailored for the heavy steel manufacturing sector. Engineered fault-tolerant telemetry hardware capable of real-time sensor processing in high-EMI environments.",
    skills: ["IIoT Telemetry", "EMI/EMC Shielding", "SCADA"]
  }
];

export default ResumeApi;